var TemplateList = require('./core/template-list');

module.exports = new TemplateList();
